import { z } from "zod";

export const placeIdSchema = z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);

export const placeSchema = z.object({
  id: placeIdSchema,
  label: z.string().min(1),
  /** Site that contains this place. Only one level deep. */
  parentId: placeIdSchema.optional(),
});

export const placesFileSchema = z.object({
  places: z.array(placeSchema),
});

export type Place = z.infer<typeof placeSchema>;
export type PlacesFile = z.infer<typeof placesFileSchema>;
